import { Text, Button, OrderList, Card } from "../../../components";
import Localization from "../../../localization";
import { Constants } from "../../../utils";
import { Images } from "../../../assets";
import styled from "styled-components";
import { Flex } from "antd";
import React from "react";

const descriptions = [
  [
    Localization.general.connect,
    <Text
      level="text"
      weight={400}
      color="inherit"
      lineHeight="inherit"
      children={` (${Localization.purchase.info_1_aside})`}
    />,
  ],
  [
    Localization.general.alarmSMS,
    <Text
      level="text"
      weight={400}
      color="inherit"
      lineHeight="inherit"
      children={` (${Localization.purchase.info_2_aside})`}
    />,
  ],
  Localization.purchase.info_3,
  Localization.purchase.info_4,
];

const Details = ({ hasAlarm = false, setHasAlarm = () => {} }) => {
  return (
    <Styled>
      <Card className="info" background={`url(${Images.servicesInfoCardBg})`}>
        <Text
          level={2}
          weight={700}
          type="tertiary"
          lineHeight="3rem"
          children={Localization.purchase.title}
        />
        <Text
          type="tertiary"
          weight={"600"}
          className="m-25-t"
          children={Localization.purchase.subtitle}
        />
        <OrderList
          prefix="bullet"
          className="m-25-t"
          items={descriptions}
          textType="tertiary"
          bulletType="tertiary"
        />
        <Button
          type="primary"
          color="tertiary"
          className="m-30-t"
          title={Localization.general.read_more}
          onClick={() => window.open(Constants.Project.urls.alarmServices)}
        />
      </Card>
      <Card>
        <Text
          level={4}
          weight={"700"}
          color="secondary"
          lineHeight="normal"
          className="m-30-b"
          children={Localization.purchase.alarm_conf_para}
        />
        <Flex gap="1em">
          <Button
            className="p-40-h"
            title={Localization.general.yes}
            onClick={() => setHasAlarm(true)}
            type={hasAlarm && "primary"}
          />
          <Button
            className="p-40-h"
            title={Localization.general.no}
            onClick={() => setHasAlarm(false)}
            type={!hasAlarm && "primary"}
          />
        </Flex>
      </Card>
    </Styled>
  );
};

const Styled = styled.div`
  .ant-card {
    margin-bottom: 2rem;
  }
  .info {
    ${(_) => _.theme.mobile(`background: ${_.theme.token.colorPrimary};`)}
    .ant-card-body {
      padding-right: 12.8rem;
      ${(_) => _.theme.mobile(`padding-right: 2rem;`)}
    }
  }
`;

export default Details;
